import axios from "services/api";;
import { BaseTableRS } from 'components/pages/stock-location/models/BaseTable';
import { objectToQueryString, getMessage400Request } from '../../helpers/utils';
import { ApiResponse } from 'helpers/stockLocationHelpers';
import { getItemFromStore, setItemToStore } from '../../helpers/utils';

axios.defaults.withCredentials = true;

const baseGetFile = async (baseURL, fileName) => {
  const res = await axios({
    method: 'get',
    url: `${baseURL}`,
    responseType: 'blob',
  }).catch(res => {
    console.log('ERROR: ', { ...res });
    return null;
  });

  if (!res || res.status !== 200) return;

  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
};

const baseSearch = async (baseUrl, request) => {
  const res = await axios({
    method: 'get',
    url: `${baseUrl}?${objectToQueryString(request)}`
  }).catch(error => {
    console.log('AXIOS ERROR', error);
    return new BaseTableRS([], 0);
  });

  if (res.status !== 200) return new BaseTableRS([], 0);

  return new BaseTableRS(res.data?.data?.items, res.data?.data?.total);
};

const baseGet = async (baseURL, id) => {
  const result = new ApiResponse();
  const res = await axios({
    method: 'get',
    url: `${baseURL}/${id}`
  }).catch(res => {
    console.log('ERROR: ', { ...res });
    result.message = getMessage400Request(res);
    return result;
  });

  if (res.status !== 200) {
    return result;
  }
  result.success = res.data.success;
  result.data = res.data?.data;
  result.message = res.data?.message;
  return result;
};


const baseGetWithoutParam = async (baseURL, config = {}) => {
  const result = new ApiResponse();
  const res = await axios({
    method: 'get',
    url: `${baseURL}`,
    ...config
  }).catch(res => {
    console.log('ERROR: ', { ...res });
    result.message = getMessage400Request(res);
    return result;
  });

  if (res.status !== 200) {
    return result;
  }
  result.success = res.data.success;
  result.data = res.data?.data;
  result.message = res.data?.message;
  return result;
};

const basePost = async (baseURL, request) => {
  const result = new ApiResponse();
  if (!request) return result;
  const res = await axios({
    method: 'post',
    url: baseURL,
    data: { ...request },
    config: {
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    }
  }).catch(error => {
    console.log('ERROR: ', { ...error });
    return result;
  });
  if (res.status !== 200) {
    return result;
  }

  result.success = res.data.success;
  result.data = res.data?.data;
  result.message = res.data?.message;
  return result;
};

const basePostArray = async (baseURL, request) => {
  const result = new ApiResponse();
  if (!request) return result;
  const res = await axios({
    method: 'post',
    url: baseURL,
    data: request,
    config: {
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    }
  }).catch(error => {
    console.log('ERROR: ', { ...error });
    return result;
  });
  if (res.status !== 200) {
    return result;
  }

  result.success = res.data.success;
  result.data = res.data?.data;
  result.message = res.data?.message;
  return result;
};

const basePut = async (baseURL, dataRQ, id) => {
  const result = new ApiResponse();
  if (!dataRQ || id <= 0) return result;
  const res = await axios({
    method: 'put',
    url: `${baseURL}/${id}`,
    data: dataRQ,
    config: {
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    }
  }).catch(error => {
    console.log('ERROR: ', { ...error });
    return result;
  });

  if (res.status !== 200) {
    return result;
  }
  result.success = res.data.success;
  result.data = res.data?.data;
  result.message = res.data?.message;
  return result;
};

const baseGetNoId = async baseURL => {
  const result = new ApiResponse();
  const res = await axios({
    method: 'get',
    url: `${baseURL}`
  }).catch(res => {
    console.log('ERROR: ', { ...res });
    result.message = getMessage400Request(res);
    return result;
  });

  if (res.status !== 200) {
    return result;
  }
  result.success = res.data.success;
  result.data = res.data?.data;
  result.message = res.data?.message;
  return result;
};

const baseGetArraySaveToSession = async (key, url) => {
  const cache = getItemFromStore(key, [], sessionStorage);
  if (cache && cache.length) return cache;

  let data = await axios({
    method: 'get',
    url: url
  })
    .then(res => {
      if (res.status !== 200) return [];
      if (Array.isArray(res.data)) {
        return res.data;
      }
      return res.data?.data;
    })
    .catch(err => {
      console.log(err);
      return [];
    });
  setItemToStore(key, JSON.stringify(data), sessionStorage);
  return data;
};
const basePatchOnlyUrl = async (baseURL, dataRQ) => {
  const result = new ApiResponse();
  const res = await axios({
    method: 'patch',
    url: `${baseURL}`,
    data: dataRQ,
    config: {
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    }
  }).catch(error => {
    console.log('ERROR: ', { ...error });
    return result;
  });

  if (res.status !== 200) {
    return result;
  }
  result.success = res.data.success;
  result.data = res.data?.data;
  result.message = res.data?.message;
  return result;
};

const basePatch = async (baseURL, dataRQ, id) => {
  const result = new ApiResponse();
  if (!dataRQ || id <= 0) return result;
  const res = await axios({
    method: 'patch',
    url: `${baseURL}/${id}`,
    data: dataRQ,
    config: {
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    }
  }).catch(error => {
    console.log('ERROR: ', { ...error });
    return result;
  });

  if (res.status !== 200) {
    return result;
  }
  result.success = res.data.success;
  result.data = res.data?.data;
  result.message = res.data?.message;
  return result;
};

const basePatchNoId = async (baseURL, dataRQ) => {
  const result = new ApiResponse();
  if (!dataRQ) return result;
  const res = await axios({
    method: 'patch',
    url: `${baseURL}`,
    data: dataRQ,
    config: {
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    }
  }).catch(error => {
    console.log('ERROR: ', { ...error });
    return result;
  });

  if (res.status !== 200) {
    return result;
  }
  result.success = res.data.success;
  result.data = res.data?.data;
  result.message = res.data?.message;
  return result;
};

const baseDelete = async (baseURL, id) => {
  const result = new ApiResponse();
  if (id == null || id <= 0) return result;

  const res = await axios({
    method: 'delete',
    url: `${baseURL}/${id}`,
    config: {
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json'
      }
    }
  }).catch(error => {
    console.log('ERROR: ', { ...error });
    return result;
  });

  if (res.status !== 200) {
    return result;
  }
  result.success = res.data.success;
  result.data = res.data?.data;
  result.message = res.data?.message;
  return result;
};

export {
  baseGetFile,
  baseSearch,
  baseGet,
  basePut,
  basePost,
  basePostArray,
  basePatch,
  basePatchOnlyUrl,
  baseGetArraySaveToSession,
  baseGetWithoutParam,
  baseDelete,
  baseGetNoId,
  basePatchNoId,
};
